import type { ReactNode } from "react";
import { useCanWrite } from "../hooks/useCanWrite";

export function CanWrite({ children, fallback = null }: { children: ReactNode; fallback?: ReactNode }) {
  return useCanWrite() ? <>{children}</> : <>{fallback}</>;
}
